// Number/currency formatters for the Bundle Calculator UI.
// Ported 1:1 from taibokuc/bundlecalc `src/utils/formatters.ts`.

export const formatNumber = (value, precision = 2) => {
  if (!Number.isFinite(value)) return '0';
  if (value === 0) return '0';
  if (Math.abs(value) < 1e-10) return '0.000000000000';
  if (Math.abs(value) < 1e-6) return parseFloat(value.toFixed(12)).toString();
  return value.toLocaleString(undefined, {
    maximumFractionDigits: precision,
    minimumFractionDigits: Math.min(
      precision,
      value >= 1000 ? 0 : value >= 100 ? 1 : value >= 1 ? 2 : 5
    ),
  });
};

export const formatCurrency = (value) => {
  if (!Number.isFinite(value)) return '$0.00';
  if (value === 0) return '$0.00';
  if (value < 1e-10) return '$0.000000000000';
  if (value < 1e-6) return `$${parseFloat(value.toFixed(12)).toString()}`;
  if (value >= 1e9) return `$${(value / 1e9).toFixed(2)}B`;
  if (value >= 1e6) return `$${(value / 1e6).toFixed(2)}M`;
  if (value >= 1e3) return `$${(value / 1e3).toFixed(2)}K`;
  if (value < 0.001) return `$${parseFloat(value.toFixed(8)).toString()}`;
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: value < 1 ? 6 : 2,
  })}`;
};

export const formatTokenPrice = (value) => {
  if (!Number.isFinite(value)) return '0.00000';
  if (value === 0) return '0.00000';
  if (Math.abs(value) < 1e-10) return '0.000000000000';
  if (Math.abs(value) < 1e-6) {
    const trimmed = parseFloat(value.toFixed(12));
    return trimmed < 1e-8 ? trimmed.toFixed(12).replace(/\.?0+$/, '') : trimmed.toString();
  }
  if (Math.abs(value) < 1) return value.toFixed(5);
  return value.toFixed(2);
};

export const formatTokenPriceNative = (value) => {
  if (!Number.isFinite(value)) return '0.00000000';
  if (value === 0) return '0.00000000';
  const abs = Math.abs(value);
  if (abs < 1e-15) return '0.000000000000000';
  if (abs < 1e-12) return value.toFixed(15).replace(/\.?0+$/, '');
  if (abs < 1e-9)  return value.toFixed(12).replace(/\.?0+$/, '');
  if (abs < 1e-6)  return value.toFixed(9).replace(/\.?0+$/, '');
  if (abs < 1)     return value.toFixed(8).replace(/\.?0+$/, '');
  return value.toFixed(2);
};

export const formatCurrencyTiny = (value) => {
  if (!Number.isFinite(value)) return '$0.000000000';
  if (value === 0) return '$0.000000000';
  if (value < 1e-15) return '$0.000000000000000';
  if (value < 1e-12) return `$${value.toFixed(15).replace(/\.?0+$/, '')}`;
  if (value < 1e-9)  return `$${value.toFixed(12).replace(/\.?0+$/, '')}`;
  if (value < 1e-6)  return `$${value.toFixed(9).replace(/\.?0+$/, '')}`;
  if (value < 0.001) return `$${value.toFixed(6).replace(/\.?0+$/, '')}`;
  return formatCurrencyCompact(value);
};

export const formatCurrencyCompact = (value) => {
  if (!Number.isFinite(value)) return '$0';
  if (value === 0) return '$0';
  if (value < 1e-10) return '$0.00000000000';
  if (value < 1e-6) return `$${parseFloat(value.toFixed(11)).toString()}`;
  if (value >= 1e9) return `$${(value / 1e9).toFixed(1)}B`;
  if (value >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
  if (value >= 1e3) return `$${(value / 1e3).toFixed(1)}K`;
  if (value < 0.001) return `$${parseFloat(value.toFixed(6)).toString()}`;
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: value >= 1 ? 2 : 0,
    maximumFractionDigits: value < 1 ? 4 : 2,
  })}`;
};

export const formatPercentage = (value) => {
  if (!Number.isFinite(value)) return '0.00%';
  return `${value.toFixed(2)}%`;
};
